import { TitleFieldProps } from '@rjsf/utils';
import { SectionTitle } from 'components/form/SectionTitle';

export default function TitleFieldTemplate(props: TitleFieldProps) {
  const { title, id } = props;

  return <SectionTitle id={id} title={title} />;
}
